import { css } from "@emotion/react";
import { ButtonV2 } from "src/components/ButtonV2/ButtonV2.tsx";
import { loadTranslations } from "src/lib/i18next/loadTranslations.ts";
import { TranslationNamespaceEnum } from "src/lib/i18next/types.ts";
import { useTranslation } from "react-i18next";

await loadTranslations(TranslationNamespaceEnum.UnexpectedError);

export const UnexpectedError = ({
  error,
  onReset,
}: {
  error: unknown;
  onReset?: () => void;
}) => {
  const { t } = useTranslation(TranslationNamespaceEnum.UnexpectedError);
  return (
    <div css={rootStyle}>
      <div> {t("title")}</div>

      {onReset && (
        <div>
          <ButtonV2 size={"sm"} onClick={onReset}>
            {t("action")}
          </ButtonV2>
        </div>
      )}
    </div>
  );
};

const rootStyle = css`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  width: 100%;
  gap: 10px;
  height: 100%;
`;
